"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.catchPromiseError = catchPromiseError;
var _checkoutUtils = require("@ori/checkout-utils");
var _constants = require("../constants");
async function catchPromiseError(promise, description) {
  const catchError = (0, _checkoutUtils.getPromiseErrorCatcher)(_constants.APP_NAME);
  return catchError(promise, description);
}